import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {Skeleton} from '@/components/ui/skeleton/Skeleton'

export const HomeReportsSkeleton = () => {
    return (
        <Flexbox direction="column" gap={4}>
            {/* Main number */}
            <Skeleton width={40} height={38} />

            {/* Statistics section */}
            <Flexbox direction="column" gap={2}>
                <Flexbox gap={2}>
                    <Skeleton width={8} height={16} />
                    <Skeleton width={120} height={16} />
                </Flexbox>
                <Flexbox gap={2}>
                    <Skeleton width={8} height={16} />
                    <Skeleton width={100} height={16} />
                </Flexbox>
            </Flexbox>
        </Flexbox>
    )
}
